export default __webpack_public_path__ + "static/media/icon-close.deab3eaf.svg";